<template>
  <div
    class="patrolRoute mainPageBg"
    v-loading="$store.state.user.loadingState"
  >
    <div class="sheetsContent commonOrderContent">
      <div class="formBox">
        <el-form :inline="true" :model="formInline" class="demo-form-inline">
          <el-form-item label="搜索">
            <el-input
              v-model="formInline.name"
              placeholder="请输入巡检路线名称"
              clearable
            ></el-input>
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              @click="
                currentPage = 1;
                handleSizeChange(10);
              "
              >查询</el-button
            >
          </el-form-item>
          <el-form-item
            v-if="judgeAuthority('houqinguanli:xunjianguanli:patrolRoute:edit')"
          >
            <el-button
              type="warning"
              icon="el-icon-plus"
              @click="
                editRouter = true;
                activeItem = {};
              "
              >新增巡检路线</el-button
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary" plain
              v-if="
                judgeAuthority('houqinguanli:xunjianguanli:patrolRoute:export')
              "
              @click="exportExcel"
              ><i class="el-icon-download el-icon--left"></i>EXCEL</el-button
            >
          </el-form-item>
        </el-form>
      </div>
      <div class="tabCardBox">
        <div class="orderCardItem">
          <el-table
            :data="tableData"
            stripe
            border
            style="width: 100%"
            class="tabWrap"
            height="93%"
            :header-cell-style="{
              'background-color': '#F7F7F7',
            }"
          >
            <el-table-column
              v-for="(v, i) in tabHead"
              :key="i"
              :prop="v.prop"
              :label="v.label"
              align="center"
              :width="v.prop != 'name' && v.prop != 'remark' ? '160' : ''"
            ></el-table-column>
            <el-table-column
              label="操作"
              width="160"
              align="center"
              v-if="
                judgeAuthority('houqinguanli:xunjianguanli:patrolRoute:edit')
              "
            >
              <template slot-scope="scope">
                <el-button
                  type="text"
                  size="small"
                  @click="
                    editRouter = true;
                    activeItem = scope.row;
                  "
                  >编辑</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="deleteClick(scope.row)"
                  >删除</el-button
                >
                <el-button
                  type="text"
                  size="small"
                  @click="
                    routePoint = true;
                    activeItem = scope.row;
                  "
                  >巡检点</el-button
                >
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
            :current-page="currentPage"
            :page-sizes="[10, 30, 50, 100]"
            :page-size="page.size"
            layout="total, sizes, prev, pager, next, jumper"
            :total="page.total"
            style="margin-top: 10px; text-align: right"
          >
          </el-pagination>
        </div>
      </div>
    </div>
    <!-- 新建编辑路线 -->
    <AddPatrolRouter v-if="editRouter" :activeItem="activeItem" />
    <!-- 巡检点列表 -->
    <RoutePointCom v-if="routePoint" :activeItem="activeItem" />
  </div>
</template>

<script>
import api from "@/api";
import AddPatrolRouter from "@/components/houqinguanli/xunjianguanli/AddPatrolRouter";
import RoutePointCom from "@/components/houqinguanli/xunjianguanli/RoutePointCom";
import { dateFtt, judgeAuthority, exportExcelFun } from "@/assets/js/utils";
import exportFile from "@/assets/js/xlsxFile";
import XLSX from "xlsx";
export default {
  components: {
    AddPatrolRouter,
    RoutePointCom,
  },
  data() {
    return {
      editRouter: false,
      routePoint: false,
      formInline: {
        name: "",
      },
      tabHead: [
        { label: "巡检线路", prop: "name" },
        { label: "创建时间", prop: "time" },
        { label: "巡检点数量", prop: "pointSize" },
        { label: "本月巡检次数", prop: "monthCount" },
        { label: "本年巡检次数", prop: "yearCount" },
        { label: "最近巡检时间", prop: "lastTime" },
        { label: "备注", prop: "remark" },
      ],
      tableData: [],
      currentPage: 1,
      page: {
        total: null,
        size: 10,
      },
      activeItem: {},
    };
  },
  methods: {
    judgeAuthority,
    deleteClick(row) {
      this.$confirm("此操作将删除该巡检路线, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          return new Promise(async (resolve) => {
            let res = await api.patrolPouteDeleteLine({}, row.id);
            if (res && res.data.code == 200) {
              this.$message.success("删除成功!");
              this.$store.commit("SET_LOADING", true);
              setTimeout(() => {
                this.getList();
              }, 1000);
            }
            resolve();
          });
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.page.size = val;
      this.currentPage = 1;
      this.getList();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.getList();
    },
    async getList() {
      this.tableData = [];
      this.$store.commit("SET_LOADING", true);
      let res = await api.patrolPouteGetList({
        pageSize: this.page.size,
        page: this.currentPage - 1,
        name: this.formInline.name,
        sourceType: "INSPECTION",
      });
      if (res && res.data.code == 200) {
        this.$store.commit("SET_LOADING", false);
        this.tableData = res.data.data.data;
        this.page.total = res.data.data.totalElements;
        this.tableData.forEach((v) => {
          v.time = v.createdTime
            ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.createdTime))
            : "";
          v.lastTime = v.lastInspectionTime
            ? dateFtt("yyyy-MM-dd hh:mm", new Date(v.lastInspectionTime))
            : "";
        });
      }
    },
    exportExcel() {
      exportFile.xlsxFile(XLSX, "巡检路线", {
        excel: exportExcelFun(this.tabHead, this.tableData),
      });
    },
  },
  created() {
    this.formInline.name = this.$route.params.name ?? "";
    this.getList();
  },
};
</script>

<style lang="scss" scoped>
.patrolRoute {
  @include setFlexCenter;
  .sheetsContent {
    width: 98%;
    height: 96%;
    ::v-deep .el-select .el-input__inner {
      vertical-align: bottom !important;
    }
    ::v-deep .el-input--suffix .el-input__inner {
      vertical-align: bottom !important;
    }
  }
}
</style>
